<template>
  <div class="vld-parent" ref="startup_batches">
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você confere cada batch de aceleração Stars que sua startup
              está participando. Em cada batch, é possível ver com detalhes o
              programa de acompanhamento e as demais startups participantes.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <batch-list v-if="!empty" :data="batches" />
          <div v-else class="row">
            <div class="col-12 text-center">
              <badge type="info" class="bg-white">
                A startup não está cadastrada em nenhum batch até o momento
              </badge>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="showModal"
      :closeOnClick="false"
      modal-classes="modal-dialog-centered modal-default"
    >
      <h6 class="modal-title mb-5" id="modal-title-notification">Atenção!</h6>
      <div class="text-center">
        <i class="fa fa-exclamation-circle fa-3x"></i>
        <h4 class="heading mt-4">Prezado(a),</h4>
        <p class="my-4">
          A startup não está vinculada a nenhum
          <span class="text-warning font-weight-400">batch STARS</span>
          até o momento. Em caso de dúvidas, sinta-se livre para
          <base-button
            type="danger"
            class="ml-auto"
            size="sm"
            @click="$router.push('/startup/suporte')"
            >Contatar o suporte
          </base-button>
        </p>
        <p class="text-right mt-4">
          Cordialmente,<br />
          <span class="font-weight-600"
            >Equipe <span class="text-warning">STARS</span></span
          >.
        </p>
      </div>
      <template slot="footer">
        <base-button type="white" @click="$router.push('/')">
          Voltar
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

import BatchList from "@/components/BatchList";

export default {
  name: "batches",
  components: {
    BatchList,
  },
  data() {
    return {
      batches: [],
      empty: false,
      showModal: false,
    };
  },
  async mounted() {
    let loader = this.$loading.show({
      container: this.$refs.startup_batches,
      width: 150,
      height: 150,
      color: "#ffffff",
      backgroundColor: "transparent",
    });
    try {
      const { data } = await api.get("/startup-batches");
      if (data.length) this.batches = data;
      else this.empty = this.showModal = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
    }
  },
};
</script>
<style></style>
